import styled from 'styled-components'

export const SpinnerContanier = styled.div<{ componentStyle?: string }>`
    ${(props) => props.componentStyle}

    div {
        height: 20px;
        width: 20px;
    }

    display: flex;
    align-items: center;
    justify-content: center;
`

export const IframeContainer = styled.div<{ componentStyle?: string }>`
    ${(props) => props.componentStyle}

    overflow: hidden;
    padding: 0px;
    margin: 0px;

    border: var(--dashboard-legend-border);
    border-radius: 5px;

    iframe {
        height: 100%;
        overflow: hidden;
        padding: 0px;
        margin: 0px;
    }
`
